(function () {
  var CONTAINER_SELECTOR = "[data-skeepers-container]";
  var MAX_ATTEMPTS = 20;
  var RETRY_DELAY = 250;

  function initializeSkeepersWidget(container) {
    if (container.dataset.skeepersInitialized === "true") return;

    var widget = container.querySelector("skp-widget");
    var heading = container.querySelector(".skeeper_header");

    if (!widget || !heading || !window.customElements) return;

    container.dataset.skeepersInitialized = "true";
    heading.hidden = true;

    window.customElements.whenDefined("skp-widget").then(function () {
      var attemptsRemaining = MAX_ATTEMPTS;

      function checkForContent() {
        var widgetContent = widget.shadowRoot
          ? widget.shadowRoot.querySelector("div")
          : null;

        if (widgetContent) {
          heading.hidden = false;
          return;
        }

        attemptsRemaining -= 1;

        if (attemptsRemaining > 0) {
          window.setTimeout(checkForContent, RETRY_DELAY);
        }
      }

      checkForContent();
    });
  }

  function initializeSkeepersWidgets(scope) {
    var root = scope || document;

    if (root.matches && root.matches(CONTAINER_SELECTOR)) {
      initializeSkeepersWidget(root);
    }

    root.querySelectorAll(CONTAINER_SELECTOR).forEach(initializeSkeepersWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeSkeepersWidgets();
    });
  } else {
    initializeSkeepersWidgets();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeSkeepersWidgets(event.target);
  });
})();
